// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"700":"84abaa19","897":"bd7caab3","911":"8405f8c7","971":"355f5060"}[chunkId] + ".css";
};